"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResolverConfigs = exports.useDisclaimer = exports.resolveDisclaimerCalls = exports.parseNamespaceInCodeArray = exports.normalizeCodeArray = exports.isTextDisclaimer = exports.default = exports.createDisclaimerQueryKey = exports.convertTupleToString = exports.codePropToArray = exports.addImplictDisclaimerCodeTuple = exports.Tooltip = exports.InlineDisclaimer = exports.DisclaimerProvider = exports.DisclaimerContext = exports.Disclaimer = void 0;
var _reactQuery = require("@tanstack/react-query");
var _immer = require("immer");
var _lodashEs = require("lodash-es");
var _react = require("react");
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _config = require("../../packages/config");
var _styledComponentThemes = require("../../packages/styled-component-themes");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Scrollbar = _interopRequireDefault(require("../Scrollbar"));
var brand = _interopRequireWildcard(require("./index.themes"));
var _react2 = require("@floating-ui/react");
var Styled = _interopRequireWildcard(require("./index.styled"));
var resolvers = _interopRequireWildcard(require("./resolvers"));
var _jsxRuntime = require("react/jsx-runtime");
// Returns a function to be used with react-query's queryfn
const resolveDisclaimerCalls = function (_ref) {
  let {
    codes = [],
    resolvers = {},
    query = {},
    resolverConfigs = {}
  } = _ref;
  return function () {
    return Promise.all(codes === null || codes === void 0 ? void 0 : codes.map(function (_ref2) {
      var _resolvers$lowerNames;
      let [namespace, code] = _ref2;
      const lowerNamespace = namespace.toLowerCase();
      const endpoint = resolverConfigs[lowerNamespace];
      return ((_resolvers$lowerNames = resolvers[lowerNamespace]) === null || _resolvers$lowerNames === void 0 ? void 0 : _resolvers$lowerNames.call(resolvers, {
        code,
        query,
        endpoint
      })) || `No resolver found for namespace: "${lowerNamespace}"`;
    }));
  };
};
exports.resolveDisclaimerCalls = resolveDisclaimerCalls;
const convertTupleToString = function (i) {
  var _i$join$replace, _i$join;
  return (_i$join$replace = (_i$join = i.join) === null || _i$join === void 0 ? void 0 : _i$join.call(i, "-").replace(/\s/g, "-")) !== null && _i$join$replace !== void 0 ? _i$join$replace : i;
};

// Combines `disclaimer` with the code to create a query key for react-query
exports.convertTupleToString = convertTupleToString;
const createDisclaimerQueryKey = function (codes) {
  return ["disclaimer", ...codes.map(function (i) {
    return convertTupleToString(i);
  })];
};

// Splits up disclaimer code strings, separated by a provided delimiter.
exports.createDisclaimerQueryKey = createDisclaimerQueryKey;
const codePropToArray = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
  if (Array.isArray(code)) {
    return code;
  }
  return code.split(delimiter);
};
exports.codePropToArray = codePropToArray;
const parseNamespaceInCodeArray = function () {
  let codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return codes.map(function (i) {
    if (Array.isArray(i)) {
      return i;
    }
    return i.split(":").map(function (j) {
      return j.trim();
    });
  });
};

// Assumption for implicit text disclaimer casting
exports.parseNamespaceInCodeArray = parseNamespaceInCodeArray;
const isTextDisclaimer = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return code.indexOf(" ") > -1;
};

// Adds a namespace to disclaimer code array if one didn't already exist
exports.isTextDisclaimer = isTextDisclaimer;
const addImplictDisclaimerCodeTuple = function (code, defaultNamespace) {
  if (code.length === 1) {
    if (isTextDisclaimer(code[0])) {
      code.unshift("txt");
    } else {
      code.unshift(defaultNamespace);
    }
  }
  return code;
};

// Normalizes array of disclaimer codes to an array of tuples [namespace, code]
exports.addImplictDisclaimerCodeTuple = addImplictDisclaimerCodeTuple;
const normalizeCodeArray = function (codeArray) {
  let defaultNamespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "lds";
  return (0, _immer.produce)(codeArray, function (draft) {
    for (const index in draft) {
      const code = [codeArray[index]].flat();

      // Implicit Namespace Generation
      addImplictDisclaimerCodeTuple(code, defaultNamespace);

      // Normalize Namespace Casing
      code[0] = code[0].toLowerCase();
      codeArray[index] = code;
    }
  });
};
exports.normalizeCodeArray = normalizeCodeArray;
const DisclaimerContext = exports.DisclaimerContext = /*#__PURE__*/(0, _react.createContext)({
  namespace: "lds",
  delimiter: ",",
  query: {
    foo: "bar"
  },
  resolvers
});
const DisclaimerProvider = function (props) {
  const {
    children,
    ...rest
  } = props;
  const contextProps = (0, _react.useContext)(DisclaimerContext);
  const combinedProps = (0, _lodashEs.merge)({}, contextProps, rest);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DisclaimerContext.Provider, {
    value: combinedProps,
    "data-testid": "DisclaimerProvider",
    children: children
  });
};
exports.DisclaimerProvider = DisclaimerProvider;
const useResolverConfigs = function () {
  const config = (0, _config.useConfig)();
  return {
    vapi: config.REACT_APP_GRAPHQL_ENDPOINT,
    lds: config.REACT_APP_DISCLAIMERS_API_BASE
  };
};
exports.useResolverConfigs = useResolverConfigs;
const useDisclaimer = function (props) {
  const contextProps = (0, _react.useContext)(DisclaimerContext);
  const {
    code,
    delimiter = ",",
    query = {},
    resolvers,
    resolverConfigs,
    namespace
  } = (0, _lodashEs.merge)({}, {
    resolverConfigs: useResolverConfigs()
  }, contextProps, props);
  const codes = normalizeCodeArray(parseNamespaceInCodeArray(codePropToArray(code, delimiter)), namespace);
  const queryKey = createDisclaimerQueryKey(codes);
  return (0, _reactQuery.useQuery)({
    queryKey,
    queryFn: resolveDisclaimerCalls({
      codes,
      query,
      resolvers,
      resolverConfigs
    }),
    enabled: props.enabled
  });
};
exports.useDisclaimer = useDisclaimer;
const useFloatingUI = function (_ref3) {
  let {
    isOpen,
    setIsOpen
  } = _ref3;
  const arrowRef = (0, _react.useRef)(null);
  const {
    refs,
    floatingStyles,
    context
  } = (0, _react2.useFloating)({
    open: isOpen,
    strategy: "fixed",
    onOpenChange: setIsOpen,
    placement: "right",
    middleware: [(0, _react2.autoPlacement)({
      crossAxis: true
    }), (0, _react2.shift)(), (0, _react2.offset)(10), (0, _react2.arrow)({
      element: arrowRef
    })]
  });
  const click = (0, _react2.useClick)(context);
  const dismiss = (0, _react2.useDismiss)(context, {
    ancestorScroll: true
  });
  const role = (0, _react2.useRole)(context);

  // Merge all the interactions into prop getters
  const {
    getReferenceProps,
    getFloatingProps
  } = (0, _react2.useInteractions)([click, dismiss, role]);
  return {
    arrowRef,
    refs,
    floatingStyles,
    context,
    getReferenceProps,
    getFloatingProps
  };
};
const Tooltip = function (props) {
  const {
    className,
    content,
    children = "*"
  } = props;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const {
    arrowRef,
    refs,
    floatingStyles,
    context,
    getReferenceProps,
    getFloatingProps
  } = useFloatingUI({
    isOpen,
    setIsOpen
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Tooltip, {
    className: className,
    "data-testid": "Tooltip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TooltipTrigger, {
      type: "button",
      ref: refs.setReference,
      ...getReferenceProps()
    }), children, isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
      context: context,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TooltipPopper, {
        ref: refs.setFloating,
        style: floatingStyles,
        ...getFloatingProps(),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingArrow, {
          ref: arrowRef,
          context: context,
          height: 8,
          width: 20
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TooltipContentWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Scrollbar.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TooltipContent, {
              tabIndex: 0,
              children: content
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CloseButtonWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CloseButton, {
              type: "button",
              onClick: function () {
                return setIsOpen(false);
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                icon: "close",
                width: "100%"
              })
            })
          })]
        })]
      })
    })]
  });
};
exports.Tooltip = Tooltip;
const DisclaimerContent = function (props) {
  const {
    code
  } = props;
  const {
    data,
    isLoading
  } = useDisclaimer({
    code
  });
  if (isLoading) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-testid": "DisclaimerContent",
    children: "Loading..."
  });
  return [data].flat().map(function (i) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-testid": "DisclaimerContent",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: i
      })
    }, i);
  });
};
const Disclaimer = function (props) {
  const {
    code
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Tooltip, {
    ...props,
    content: /*#__PURE__*/(0, _jsxRuntime.jsx)(DisclaimerContent, {
      code: code
    }),
    "data-testid": "Disclaimer"
  });
};
exports.Disclaimer = Disclaimer;
const InlineDisclaimer = function (props) {
  const {
    code
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DisclaimerContent, {
    code: code,
    "data-testid": "InlineDisclaimer"
  });
};
exports.InlineDisclaimer = InlineDisclaimer;
var _default = exports.default = (0, _styledComponentThemes.withThemes)(Disclaimer, {
  brand: brand
});